var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.model.length > 0
      ? _c(
          "div",
          [
            _vm._l(_vm.companyExemptions, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "mb-2" },
                [
                  _c(
                    "custom-callout",
                    {
                      attrs: {
                        "border-color": _vm.getColor(item.exemptionStatusId)
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm d-flex justify-content-center border-right"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "w-80" },
                              [
                                _c("custom-balloon", {
                                  staticClass:
                                    "mt-2 p-2 font-weight-normal font-16",
                                  attrs: {
                                    "background-color": _vm.getColor(
                                      item.exemptionStatusId
                                    ),
                                    text: item.exemptionStatusName
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c("div", { staticClass: "col-sm" }, [
                          _c("span", { staticClass: "data-name" }, [
                            _vm._v("Fecha Sometida:")
                          ]),
                          _c("p", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.$formatDate(item.createdDate)))
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm" }, [
                          _c("span", { staticClass: "data-name" }, [
                            _vm._v("Fecha Desde:")
                          ]),
                          _c("p", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm.$formatDate(item.exemptionStartDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm" }, [
                          _c("span", { staticClass: "data-name" }, [
                            _vm._v("Fecha Hasta:")
                          ]),
                          _c("p", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm.$formatDate(item.exemptionEndDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm-2 text-center" }, [
                          _c("span", { staticClass: "data-name" }, [
                            _vm._v("Compañía")
                          ]),
                          _c("p", { staticClass: "data" }, [
                            _vm._v(_vm._s(item.companyName))
                          ])
                        ]),
                        _vm.isDEPR
                          ? _c("div", { staticClass: "col-sm text-center" }, [
                              _c("span", { staticClass: "data-name" }, [
                                _vm._v("Número de Dispensa:")
                              ]),
                              _c("p", { staticClass: "data" }, [
                                _vm._v(_vm._s(item.exemptionDprNumber))
                              ])
                            ])
                          : _c("div", { staticClass: "col-sm text-center" }, [
                              _c("span", { staticClass: "data-name" }, [
                                _vm._v("Total Supervisados:")
                              ]),
                              _c("p", { staticClass: "data" }, [
                                _vm._v(_vm._s(item.supervisedTotal))
                              ])
                            ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm d-flex h-100 justify-content-center"
                          },
                          [
                            _c("action-button", {
                              staticClass: "w-80",
                              attrs: {
                                i: "fas fa-file-search",
                                text: "Ver Detalles",
                                variant: "outline-success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.seeDetail(item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            _c(
              "custom-collapse",
              { attrs: { id: "ip-collapse" } },
              [
                _c(
                  "custom-collapse-item",
                  {
                    staticClass: "px-4 mt-4",
                    attrs: {
                      "body-background-color": "#F7F7F7",
                      checked: true,
                      expanded: false,
                      "parent-id": "ip-collapse",
                      title: "Dispensas de otras corporaciones"
                    }
                  },
                  _vm._l(_vm.otherCompaniesExemptions, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "mb-2" },
                      [
                        _c(
                          "custom-callout",
                          {
                            attrs: {
                              "border-color": _vm.getColor(
                                item.exemptionStatusId
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm d-flex justify-content-center border-right"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "w-80" },
                                    [
                                      _c("custom-balloon", {
                                        staticClass:
                                          "mt-2 p-2 font-weight-normal font-16",
                                        attrs: {
                                          "background-color": _vm.getColor(
                                            item.exemptionStatusId
                                          ),
                                          text: item.exemptionStatusName
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "col-sm" }, [
                                _c("span", { staticClass: "data-name" }, [
                                  _vm._v("Fecha Sometida:")
                                ]),
                                _c("p", { staticClass: "data" }, [
                                  _vm._v(
                                    _vm._s(_vm.$formatDate(item.createdDate))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "col-sm" }, [
                                _c("span", { staticClass: "data-name" }, [
                                  _vm._v("Fecha Desde:")
                                ]),
                                _c("p", { staticClass: "data" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$formatDate(item.exemptionStartDate)
                                    )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "col-sm" }, [
                                _c("span", { staticClass: "data-name" }, [
                                  _vm._v("Fecha Hasta:")
                                ]),
                                _c("p", { staticClass: "data" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$formatDate(item.exemptionEndDate)
                                    )
                                  )
                                ])
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-sm-2 text-center" },
                                [
                                  _c("span", { staticClass: "data-name" }, [
                                    _vm._v("Compañía")
                                  ]),
                                  _c("p", { staticClass: "data" }, [
                                    _vm._v(_vm._s(item.companyName))
                                  ])
                                ]
                              ),
                              _vm.isDEPR
                                ? _c(
                                    "div",
                                    { staticClass: "col-sm text-center" },
                                    [
                                      _c("span", { staticClass: "data-name" }, [
                                        _vm._v("Número de Dispensa:")
                                      ]),
                                      _c("p", { staticClass: "data" }, [
                                        _vm._v(_vm._s(item.exemptionDprNumber))
                                      ])
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "col-sm text-center" },
                                    [
                                      _c("span", { staticClass: "data-name" }, [
                                        _vm._v("Total Supervisados:")
                                      ]),
                                      _c("p", { staticClass: "data" }, [
                                        _vm._v(_vm._s(item.supervisedTotal))
                                      ])
                                    ]
                                  ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm d-flex h-100 justify-content-center"
                                },
                                [
                                  _c("action-button", {
                                    staticClass: "w-80",
                                    attrs: {
                                      i: "fas fa-file-search",
                                      text: "Ver Detalles",
                                      variant: "outline-success"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.seeDetail(item)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          ],
          2
        )
      : _c("div", [_vm._m(0)])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-12 p-4 text-center align-items-center no-info mt-4" },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12 col-lg-1 align-self-center" }, [
            _c("i", {
              staticClass: "far fa-folder-open icon no-info-icon pl-2"
            })
          ]),
          _c(
            "div",
            { staticClass: "col-12 col-lg-3 ml-lg-n4 align-self-center" },
            [
              _c("span", { staticClass: "no-info-text" }, [
                _vm._v(" El especialista no cuenta con Dispensas. ")
              ])
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }